import { Component, Input } from '@angular/core';
import { TableComponent } from '../../../../core/table/table.component';
import { ColumnComponent } from '../../../../core/table/column.component';

@Component({
  selector: 'app-risk-unit-vehicle',
  imports: [TableComponent, ColumnComponent],
  template: `<app-table
    [dataSource]="dataSource"
    [pageSize]="5"
    [scrollable]="false"
    recordLabel="Vehicle"
    [globalFilterFields]="[
      'vin',
      'year',
      'make',
      'model',
      'color',
      'tagState',
      'tagNumber',
      'vehicleId',
      'serialNumber',
    ]"
  >
    <app-column name="vin" label="VIN" width="15%" />
    <app-column name="year" label="Year" width="10%" />
    <app-column name="make" label="Make" width="10%" />
    <app-column name="model" label="Model" width="10%" />
    <app-column name="color" label="Color" width="10%" />
    <app-column name="tagState" label="Tag State" width="10%" />
    <app-column name="tagNumber" label="Tag Number" width="10%" />
    <app-column name="vehicleId" label="Vehicle ID" width="10%" />
    <app-column name="serialNumber" label="Serial Number" width="10%" />
  </app-table>`,
  styles: [],
})
export class RiskUnitVehicleComponent {
  @Input() dataSource: any;
}
